import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const PremiumRoute = () => {
  const token = localStorage.getItem("token"); // Get token from localStorage
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!token) {
        setError("Please login to access this page.");
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.get("/api/user/subscription", {
          headers: { Authorization: `Bearer ${token}` },
        });

        // console.log("User subscription plan:", response.data.current_plan); // Debugging

        if (response.data.current_plan?.toLowerCase() !== "premium") {
          setError("Upgrade to a Pro plan to access this page.");
        }
      } catch (err) {
        setError("Failed to verify subscription. Please try again.");
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscription();
  }, [token]);

  // Show loading state until we finish checking subscription
  if (isLoading) return <LoadingSpinner />;

  // If an error exists (non-premium or no login), redirect accordingly
  if (error) {
    return <Navigate to={token ? "/subscription" : "/login"} state={{ message: error }} />;
  }

  // If user is premium, allow access to the page
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PremiumRoute;
